import {
    Component,
    Input,
    OnChanges,
    SimpleChanges,
    HostBinding,
    ElementRef
} from '@angular/core'
import { trigger, state, style, transition, animate } from '@angular/animations'

@Component({
    selector: 'col-collapse',
    template: '<ng-content></ng-content>',
    styles: [':host { display: block; }'],
    animations: [
        trigger('collapse', [
            state('collapsed', style({ display: 'none' })),
            state('expanded', style({ display: 'block' })),
            transition('collapsed => expanded', [
                style({ overflow: 'hidden', height: 0 }),
                animate(
                    '350ms ease',
                    style({ overflow: 'hidden', height: '*' })
                )
            ]),
            transition('expanded => collapsed', [
                style({ overflow: 'hidden', height: '*' }),
                animate('350ms ease', style({ overflow: 'hidden', height: 0 }))
            ])
        ])
    ]
})
export class CollapseComponent implements OnChanges {
    @Input() expanded: boolean

    @HostBinding('@collapse') state: 'expanded' | 'collapsed'

    private hostElement: HTMLElement

    constructor(host: ElementRef) {
        this.hostElement = host.nativeElement
        this.expanded = false
        this.updateState()
    }

    ngOnChanges(changes: SimpleChanges) {
        if ('expanded' in changes) {
            this.updateState()
        }
    }

    private updateState() {
        this.state = this.expanded ? 'expanded' : 'collapsed'
        this.hostElement.setAttribute(
            'aria-expanded',
            this.expanded ? 'true' : 'false'
        )
    }
}



// WEBPACK FOOTER //
// ./src/app/common/collapse/collapse.component.ts